// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HomeController from "./home_controller"
application.register("home", HomeController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import ServiceItemController from "./service_item_controller"
application.register("service-item", ServiceItemController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
